import type { ClientInApp, FeatureFlags } from "../shared/types/SubscriptionTypes";

export const FEATURE_FLAGS = {
    CHECKLIST: 'checklist',
} as const;

type FeatureFlagName = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS] | string;

const localOverrides = new Map<FeatureFlagName, boolean>();

export const setLocalFeatureFlag = (flag: FeatureFlagName, enabled: boolean) => {
    localOverrides.set(flag, enabled);
};

export const clearLocalFeatureFlag = (flag: FeatureFlagName) => {
    localOverrides.delete(flag);
};

export const resetLocalFeatureFlags = () => {
    localOverrides.clear();
};

export const getActiveFeatureFlags = (client: ClientInApp): FeatureFlags => {
    const baseFlags = client?.feature_flags ?? {};

    const merged: FeatureFlags = { ...baseFlags };
    localOverrides.forEach((value, key) => {
        if (value) {
            merged[key] = true;
        } else {
            delete merged[key];
        }
    });

    return merged;
};

export const isFeatureFlagEnabled = (client: ClientInApp, flag: FeatureFlagName): boolean => {
    if (localOverrides.has(flag)) {
        return Boolean(localOverrides.get(flag));
    }

    return Boolean(client?.feature_flags?.[flag]);
};

export const getLocalFeatureFlagOverrides = () => {
    return Object.fromEntries(localOverrides.entries());
};
